import { Link } from "react-router-dom";

export default function SiteFooter() {
  return (
    <footer className="bg-secondary-900 text-secondary-100 mt-16">
      <div className="px-4 md:px-8 py-12">
        <div className="max-w-[1200px] mx-auto grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
          <div className="lg:col-span-1">
            <div className="flex items-center gap-2 mb-4">
              <span className="w-9 h-9 flex items-center justify-center rounded-md bg-primary-500 text-background-50 dark:text-foreground-950">
                <i className="ri-play-fill text-xl"></i>
              </span>
              <span className="font-heading font-bold text-xl text-white">
                在线视频
              </span>
            </div>
            <p className="text-sm leading-relaxed text-secondary-300">
              海量视频资源在线观看平台，覆盖电影、电视剧、综艺与短视频，陪你发现每一部好内容。
            </p>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">
              <Link to="/category/movie" className="cursor-pointer hover:text-primary-300">
                内容分类
              </Link>
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/category/movie" className="cursor-pointer text-secondary-300 hover:text-white">
                  电影频道
                </Link>
              </li>
              <li>
                <Link to="/category/drama" className="cursor-pointer text-secondary-300 hover:text-white">
                  电视剧频道
                </Link>
              </li>
              <li>
                <Link to="/category/variety" className="cursor-pointer text-secondary-300 hover:text-white">
                  综艺频道
                </Link>
              </li>
              <li>
                <Link to="/category/short" className="cursor-pointer text-secondary-300 hover:text-white">
                  短视频频道
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">
              <Link to="/" className="cursor-pointer hover:text-primary-300">
                快速导航
              </Link>
            </h4>
            <ul className="space-y-3 text-sm">
              <li>
                <Link to="/" className="cursor-pointer text-secondary-300 hover:text-white">
                  首页推荐
                </Link>
              </li>
              <li>
                <Link to="/search" className="cursor-pointer text-secondary-300 hover:text-white">
                  搜索视频
                </Link>
              </li>
              <li>
                <Link to="/about" className="cursor-pointer text-secondary-300 hover:text-white">
                  关于我们
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h4 className="text-white font-semibold mb-4 text-sm">
              <Link to="/about" className="cursor-pointer hover:text-primary-300">
                联系我们
              </Link>
            </h4>
            <ul className="space-y-3 text-sm text-secondary-300">
              <li className="flex items-center gap-2">
                <i className="ri-mail-line text-accent-400"></i>
                <span>service@zaixianshipin.example</span>
              </li>
              <li className="flex items-center gap-2">
                <i className="ri-time-line text-accent-400"></i>
                <span>服务时间：每日 9:00 - 22:00</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-[1200px] mx-auto mt-10 pt-6 border-t border-secondary-700 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-secondary-400">
          <p>© 2024 在线视频 · 海量视频资源在线观看平台</p>
          <p className="text-secondary-400">
            本平台为演示站点，视频播放为前端模拟，仅供学习交流使用。
          </p>
        </div>
      </div>
    </footer>
  );
}